import React, { useEffect, useCallback } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import CustomButton from 'components/RestActions/CustomButton';
import { getCompaniesOfUser } from 'redux/companiesOfUser/actions';
import CompaniesUserTable from './CompaniesUserTable';
import CompanyFilter from '../Form/CompanyFilter';

const CompaniesOfUserList = () => {
  const { push, location } = useHistory();

  const { id } = useParams();

  const dispatch = useDispatch();

  const retrieveList = useCallback(
    ({ filter = {}, isRefresh, keepFilter }) => {
      dispatch(
        getCompaniesOfUser({
          id,
          data: {
            ...filter,
            filter: {
              ...filter.filter,
            },
          },
          options: {
            isRefresh,
            isOrderBy: false,
            keepFilter,
          },
        }),
      );
    },
    [], // eslint-disable-line
  );

  useEffect(() => {
    retrieveList({
      filter: {
        limit: 10,
        offset: 0,
        orderBy: 'name',
      },
      isRefresh: true,
    });
  }, []); // eslint-disable-line

  const redirectAddMoreCompanies = () => {
    push(`${location.pathname}/addMoreCompanies`);
  };

  return (
    <div>
      <CompanyFilter greyInput={false} retrieveList={retrieveList} />
      <div className="box-wrapper">
        <div className="flex-center-between mb-20">
          <div className="title-table">{i18next.t('input.company.name')}</div>
          <CustomButton
            permissionKey="abilityChangeUserPermissions"
            isSkipSubscription
            action="isEdit"
            title="users.addMoreCompanies"
            buttonProps={{
              icon: <PlusOutlined />,
              className: 'btn-second-primary',
            }}
            handleClick={redirectAddMoreCompanies}
          />
        </div>
        <CompaniesUserTable retrieveList={retrieveList} />
      </div>
    </div>
  );
};

export default CompaniesOfUserList;
